import HubSpotSvg from '../../../../assets/icons/HubSpot.svg';
import type { ProviderIconComponent } from '../../types';

const HubSpotIcon: ProviderIconComponent = ({ size = 24 }) => (
  <span
    style={{
      width: size,
      height: size,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <HubSpotSvg style={{ width: '100%', height: '100%' }} />
  </span>
);

export default HubSpotIcon;
